module.exports = __webpack_public_path__ + "img/restaurant-location.919c5e6d.svg";